import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	isLoaded: false,
	data: { metadata: {} }
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case types.CREATE_PRODUCT_PREVIEW_DATA:
				draft.data = action.payload;
				draft.isLoaded = true;
				return;

			default:
				return state;
		}
	});
